import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-222094cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-window"
}
const _hoisted_2 = {
  key: 0,
  class: "popup-div"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Build Miros Packages", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Please enter the path to the ROS2 workspace that you want the miros packages to be built into on your robot. ", -1))
const _hoisted_5 = {
  key: 1,
  class: "popup-div"
}
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = { class: "progress-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.building)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _hoisted_4,
                _createElementVNode("div", null, [
                  _createTextVNode(" Target Workspace: "),
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Target Workspace",
                    class: "input-box long-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetDir) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.targetDir]
                  ])
                ]),
                _createElementVNode("button", {
                  class: "rectangle-button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.buildPackages()))
                }, "Build")
              ]))
            : _createCommentVNode("", true),
          (_ctx.building)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.buildingText), 1),
                (_ctx.errorText !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errorText), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "progress-bar",
                    style: _normalizeStyle({ width: `${_ctx.buildingValue}%` })
                  }, null, 4)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "dialog-bg center",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exit()))
        }))
      : _createCommentVNode("", true)
  ], 64))
}